import { LeaderboardPosition } from './hooks/useLeaderboardPositions'

export type OptionType = 'coin' | 'position' | 'wallet'

export interface CoinOption {
  type: OptionType
  displaySymbol: string
  iconUrl?: string
  name: string
  id: string
}

export interface WalletOption {
  type: OptionType
  id: string
}

export interface PositionOption {
  type: OptionType
  id: string
}

export type LeaderboardAutocompleteOption = CoinOption | WalletOption | PositionOption

export const getPositionsAutocompleteData = (
  data: LeaderboardPosition[]
): LeaderboardAutocompleteOption[] => {
  const coins = new Map<string, CoinOption>()
  const wallets = new Map<string, WalletOption>()
  const positions = new Map<string, PositionOption>()

  for (const position of data) {
    if (!coins.has(position.displayInfo.position.X.typeName)) {
      coins.set(position.displayInfo.position.X.typeName, {
        type: 'coin',
        displaySymbol: position.displayInfo.position.X.displaySymbol,
        iconUrl: position.displayInfo.position.X.iconUrl,
        name: position.displayInfo.position.X.name,
        id: position.displayInfo.position.X.typeName,
      })
    }

    if (!coins.has(position.displayInfo.position.Y.typeName)) {
      coins.set(position.displayInfo.position.Y.typeName, {
        type: 'coin',
        displaySymbol: position.displayInfo.position.Y.displaySymbol,
        iconUrl: position.displayInfo.position.Y.iconUrl,
        name: position.displayInfo.position.Y.name,
        id: position.displayInfo.position.Y.typeName,
      })
    }

    if (!wallets.has(position.ownerId)) {
      wallets.set(position.ownerId, {
        type: 'wallet',
        id: position.ownerId,
      })
    }

    positions.set(position.positionId, { type: 'position', id: position.positionId })
  }

  return [
    ...Array.from(coins.values()),
    ...Array.from(wallets.values()),
    ...Array.from(positions.values()),
  ]
}
